
import { Component, Prop, Vue } from 'vue-property-decorator'

import BasketModule from '@/store/modules/basket';

@Component({
  components: {
  }
})
export default class ProductQuantity extends Vue {
    @Prop({ type: Object }) basketProduct: BasketProduct;
    @Prop({ type: String, default: 'normal' }) size: string;
    @Prop({ type: String, default: 'quantity' }) variant: string;
    @Prop({ type: String, default: 'update' }) action: string;
    @Prop({ type: Boolean, default: false }) disabled: boolean;
    @Prop({ type: Boolean, default: false }) loading: boolean;

    async handleQuantityChange(event) {
      const basketProduct = { ...this.basketProduct };
      if (event === 'add') {
        basketProduct.quantity = this.basketProduct.quantity + 1;
      } else if (event === 'remove') {
        basketProduct.quantity = this.basketProduct.quantity - 1;
      }

      if (basketProduct.quantity < 1) {
        return;
      }

      if (this.action === 'update') {
        this.$log.info('handleQuantityChange', event, basketProduct);
        await BasketModule.updateProduct(basketProduct)
      } else if (this.action === 'add') {
        // await BasketModule.addItem(basketProduct);
        // await BasketModule.addItem({
        //   basketId: BasketModule.id,
        //   choices,
        //   productId,
        //   quantity: this.quantity, // TODO~> connect to input??
        //   specialInstructions: this.specialInstructions,
        //   recipient: this.recipient
        // });
      }
    }

    get classes() {
      return {
        'vue-button-red': this.variant === 'primary',
        'vue-button-gray': this.variant === 'secondary',
        'vue-button-darkgray': this.variant === 'tertiary',
      }
    }

    get basketProductQuantity() {
      return this.basketProduct?.quantity || 0;
    }

    async handleQuantityInputChange(event) {
      const basketProduct = { ...this.basketProduct };
      let newValue = parseInt(event.target.value, 10);
      if (newValue <= 0) {
        newValue = 1;
      } else if (newValue > 99) {
        newValue = 99
      }
      basketProduct.quantity = newValue

      await BasketModule.updateProduct(basketProduct)
    }
}
